import { render, staticRenderFns } from "./BaseButtonBottom.vue?vue&type=template&id=1ea308a8&"
import script from "./BaseButtonBottom.vue?vue&type=script&lang=js&"
export * from "./BaseButtonBottom.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonBottom.vue?vue&type=style&index=0&id=1ea308a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports